export const CoreServiceUrls = {
	FETCH_ORDER_FILTER: `${process.env.REACT_APP_CORE_SERVICE}/api/v2/order/filters`
};
